import { render, staticRenderFns } from "./ForgetPasswordCard.vue?vue&type=template&id=02d3147a&lang=pug"
import script from "./ForgetPasswordCard.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports